"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const theme = styles_1.createMuiTheme({});
exports.default = styles_1.responsiveFontSizes(theme);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF0ZXJpYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbWF0ZXJpYWwuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxxREFBK0U7QUFFL0UsTUFBTSxLQUFLLEdBQUcsdUJBQWMsQ0FBQyxFQUFFLENBQUMsQ0FBQztBQUVqQyxrQkFBZSw0QkFBbUIsQ0FBQyxLQUFLLENBQUMsQ0FBQyJ9